import React, { memo } from 'react';
import styled from 'styled-components';
import { p4Tokens } from '../../../styles/themes/default/p4FluentTheme';

const Paid = styled.div`
  border-radius: 3px;
  border: 1px solid ${p4Tokens.statusFlagSuccess};
  background-color: ${p4Tokens.statusFlagSuccess};
  color: white;
  display: inline-block;
  font-size: 11px;
  font-weight: bold;
  line-height: 99%;
  margin: 0;
  padding: 2px 5px;
  text-align: center;
  text-decoration: none;
  text-transform: uppercase;
`;

const Outstanding = styled.div`
  border-radius: 3px;
  border: 1px solid ${p4Tokens.statusFlagWarning};
  background-color: ${p4Tokens.statusFlagWarning};
  color: white;
  display: inline-block;
  font-size: 11px;
  font-weight: bold;
  line-height: 99%;
  margin: 0;
  padding: 2px 5px;
  text-align: center;
  text-decoration: none;
  text-transform: uppercase;
`;

const PartPaid = styled.div`
  border-radius: 3px;
  border: 1px solid ${p4Tokens.statusFlagInfo};
  background-color: ${p4Tokens.statusFlagInfo};
  color: white;
  display: inline-block;
  font-size: 11px;
  font-weight: bold;
  line-height: 99%;
  margin: 0;
  padding: 2px 5px;
  text-align: center;
  text-decoration: none;
  text-transform: uppercase;
`;

const PaymentStatusFormatter = (props) => {
  const { value } = props;
  switch (value) {
    case 'PAID':
      return <Paid>PAID</Paid>;
    case 'PARTPAID':
      return <PartPaid>PART PAID</PartPaid>;
    case 'REFUNDED':
      return <Paid>REFUNDED</Paid>;
    case 'PART_REFUNDED':
      return <PartPaid>PART REFUNDED</PartPaid>;
    default:
      return <Outstanding>{value}</Outstanding>;
  }
};

export default memo(PaymentStatusFormatter, (prevProps, nextProps) => prevProps.value === nextProps.value);
